module.exports = __webpack_public_path__ + "img/04 Aniamtion 3-squashed.bf83e683.jpg";